import React, {PropsWithChildren} from 'react';
import {StyleSheet, View, StyleProp, ViewStyle} from 'react-native';

export type FormControlGroupProps = {
  style?: StyleProp<ViewStyle>;
};

export const FormControlGroup: React.FC<
  PropsWithChildren<FormControlGroupProps>
> = ({children, style}) => {
  return <View style={[styles.container, style]}>{children}</View>;
};

const styles = StyleSheet.create({
  container: {},
});
